export default {
  "dataIterator": {
    "rowsPerPageText": "Zeilen pro Seite",
    "rowsPerPageAll": "Gesamt",
    "pageText": "{0}-{1} von {2}",
    "noResultsText": "No matching records found",
    "nextPage": "Next page",
    "prevPage": "Previous page"
  },
  "dataTable": {
    "rowsPerPageText": "Zeilen pro Seite",
  },
  "noDataText": "No data available"
}
